import classNames from 'classnames';
import { Frame } from '@treedis/tour-loader';
import DeviceManager from '@/components/util/deviceManager';

const LoadTourIframe = ({
  mesurementsOn,
  iframeStyle,
  iframeUrl,
  isFullScreen,
  iframeId,
  cb,
}: {
  cb: (el: any) => void;
  iframeId: string;
  iframeStyle: any;
  mesurementsOn: any;
  iframeUrl?: string | null;
  isFullScreen: boolean;
}) => {
  return (
    <Frame
      elementId={iframeId}
      iframeUrl={iframeUrl}
      className={classNames('showcase', DeviceManager.isMobile() && !isFullScreen && mesurementsOn && 'mesurements-mobile-not-fullscreen') as any}
      style={iframeStyle}
      handleRef={cb}
    />
  );
};

export default LoadTourIframe;
